<template>
  <div class="ba-flex ba-flex-col ba-w-full ba-p-10 ba-text-center">
    <h2 class="ba-mb-10 ba-text-xl ba-font-bold">{{ $t("manage.title") }}</h2>
    <div class="ba-mb-10">
      <figure class="ba-mb-4">
        <img
          src="/img/manage/password.svg"
          alt=""
          width="148"
          class="ba-inline-block ba-cursor-pointer"
          :title="$t('manage.changePassword')"
          @click.prevent="onNavigate('password')"
        />
      </figure>
      <a @click.prevent="onNavigate('password')" class="ba-mb-4">
        <i class="fa fa-lock ba-mr-3" />
        <span class="ba-cursor-pointer hover:ba-opacity-75">
          {{ $t('manage.changePasswordTitle') }}
        </span>
      </a>
    </div>
    <footer class="ba-flex ba-items-center ba-justify-center">
      <a
        @click.prevent="onReturn"
        class="ap-button-login ba-mx-auto ba-mt-2 ba-transition-all artek-gradient-light"
      >
        {{ $t('backToApp2') }}
      </a>
    </footer>
    <vis-logout-button
      class="ba-justify-center ba-mt-10"
      :state="state"
      :token="token"
    />
  </div>
</template>

<script>
export default {
  name: "vis-page-manage-main",
  props: {
    state: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    }
  },
  methods: {
    onReturn() {
      this.$emit("return");
    },
    onNavigate(view) {
      this.$emit("navigate", view);
    }
  }
};
</script>
